import { defineMessages } from 'react-intl';

export default defineMessages({
	unknownError: {
		id: 'error.boundary.title',
		defaultMessage: 'An unknown error occurred.',
		description: 'Title for an error box saying that something went wrong',
	},
	failedToRenderField: {
		id: 'error.boundary.failed.to.render.field',
		defaultMessage: "We couldn't display this field.",
		description: 'Title for an error box saying that something went wrong while rendering a field',
	},
	failedToRenderComment: {
		id: 'error.boundary.failed.to.render.comment',
		defaultMessage: "We couldn't display this comment.",
		description:
			'Title for an error box saying that something went wrong while rendering a comment',
	},
	failedToRenderCommentEditor: {
		id: 'error.boundary.failed.to.render.rich.text.editor',
		defaultMessage: "We couldn't display the comment editor.",
		description:
			'Title for an error box saying that something went wrong while rendering the comment editor',
	},
});
